import { createTheme, type MantineColorsTuple } from "@mantine/core";

// Violet tuple matched to our Tailwind accent (lead color).
const brandViolet: MantineColorsTuple = [
  "#f1eefe",
  "#ddd6fb",
  "#bcaef6",
  "#9d8af2",
  "#8a78f0",
  "#7c64ec",
  "#6f5be0",
  "#5b48c4",
  "#4a3aa0",
  "#392d7d",
];

// Zinc tuple - used as a neutral so Mantine surfaces look like the rest of the app.
const zinc: MantineColorsTuple = [
  "#fafafa",
  "#f4f4f5",
  "#e4e4e7",
  "#d4d4d8",
  "#a1a1aa",
  "#71717a",
  "#52525b",
  "#3f3f46",
  "#27272a",
  "#18181b",
];

export const theme = createTheme({
  colors: {
    brandViolet,
    zinc,
  },
  primaryColor: "brandViolet",
  primaryShade: { light: 5, dark: 4 },
  fontFamily:
    'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif',
  fontFamilyMonospace:
    '"JetBrains Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, "Liberation Mono", monospace',
  headings: {
    fontFamily:
      'Inter, ui-sans-serif, system-ui, -apple-system, "Segoe UI", sans-serif',
    fontWeight: "700",
  },
  defaultRadius: "md",
  radius: {
    xs: "6px",
    sm: "8px",
    md: "12px",
    lg: "16px",
    xl: "22px",
  },
  cursorType: "pointer",
  components: {
    Modal: {
      defaultProps: {
        radius: "lg",
        overlayProps: { backgroundOpacity: 0.6, blur: 3 },
      },
      styles: {
        content: {
          background: "var(--color-panel)",
          border: "1px solid var(--color-border)",
          color: "var(--color-fg)",
          boxShadow: "var(--shadow-lift)",
        },
        header: {
          background: "var(--color-panel)",
          borderBottom: "1px solid var(--color-border)",
        },
        title: {
          fontWeight: 700,
        },
      },
    },
    Drawer: {
      defaultProps: { radius: "lg" },
      styles: {
        content: {
          background: "var(--color-panel)",
          borderLeft: "1px solid var(--color-border)",
        },
        header: {
          background: "var(--color-panel)",
          borderBottom: "1px solid var(--color-border)",
        },
      },
    },
    Notification: {
      defaultProps: { radius: "md" },
      styles: {
        root: {
          background: "var(--color-panel)",
          border: "1px solid var(--color-border)",
        },
      },
    },
    Tooltip: {
      defaultProps: { radius: "md", color: "dark" },
    },
    Badge: {
      styles: {
        label: { fontWeight: 500 },
      },
    },
    // Render description below the input instead of between label and input.
    // Without this, a row of inputs where only some have descriptions will
    // misalign vertically because Mantine pushes those inputs down. With this,
    // every label and input lands at the same Y; descriptions float beneath.
    InputWrapper: {
      defaultProps: {
        inputWrapperOrder: ["label", "input", "description", "error"],
      },
    },
  },
});
